import { memo, useCallback, useState } from 'react';

const InlineEditableText = ({ value, placeholder = '', variant = 'description', onChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draftValue, setDraftValue] = useState(value || '');

  const commitEdit = useCallback(() => {
    setIsEditing(false);
    onChange?.(draftValue.trim());
  }, [draftValue, onChange]);

  const cancelEdit = useCallback(() => {
    setDraftValue(value || '');
    setIsEditing(false);
  }, [value]);
  const startEdit = useCallback(() => {
    setDraftValue(value || '');
    setIsEditing(true);
  }, [value]);

  const inputClass =
    variant === 'title'
      ? 'h-7 min-w-[220px] text-xl font-semibold leading-6'
      : 'h-6 min-w-[320px] text-xs font-medium leading-4';

  const textClass =
    variant === 'title'
      ? 'text-xl font-semibold leading-6 whitespace-nowrap'
      : 'text-xs font-medium leading-4';

  const displayValue = value || placeholder;
  const isPlaceholder = !value;

  if (isEditing) {
    return (
      <input
        autoFocus
        value={draftValue}
        onChange={(event) => setDraftValue(event.target.value)}
        onBlur={commitEdit}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            commitEdit();
          }
          if (event.key === 'Escape') {
            event.preventDefault();
            cancelEdit();
          }
        }}
        className={`rounded-md border border-brand-500 bg-surface px-1.5 text-content outline-none ring-offset-surface focus:ring-2 focus:ring-brand-500/30 dark:ring-offset-surface ${inputClass}`}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={startEdit}
      className="min-w-0 cursor-text text-left"
    >
      <span className={`${textClass} ${isPlaceholder ? 'text-content-muted' : 'text-content'}`}>{displayValue}</span>
    </button>
  );
};

export default memo(InlineEditableText);
